/* eslint-disable max-lines */

export const PLAN_STATUS_LABELS = {
  /* eslint-disable sort-keys */
  AWAITING_SCHEDULE: 'Awaiting schedule',
  DRAFT: 'Draft',
  RESERVED: 'Reserved',
  BOOKING_REQUESTED: 'Booking requested',
  BOOKED: 'Booked',
  CANCEL_BOOKING_REQUESTED: 'Cancellation requested',
  CANCELLED: 'Cancelled',
  /* eslint-enable sort-keys */
};

export const CAMPAIGNS_PAGE_LABELS = {
  CAMPAIGN: 'Campaign',
  CAMPAIGN_ADVERTISER: 'Advertiser',
  CAMPAIGN_AGENCY: 'Agency',
  CAMPAIGN_ID: 'Campaign ID',
  CAMPAIGN_NAME: 'Campaign Name',
  CAMPAIGN_NO_PLANS: 'No Plans for Campaign',
  CAMPAIGN_PLANS_PLAN_ACTIONS: 'Actions',
  CAMPAIGN_PLANS_PLAN_DATE_RANGE: 'Date Range',
  CAMPAIGN_PLANS_PLAN_FORMAT: 'Format',
  CAMPAIGN_PLANS_PLAN_FRAMES: 'Frames',
  CAMPAIGN_PLANS_PLAN_ID: 'Plan ID',
  CAMPAIGN_PLANS_PLAN_LAST_MODIFIED_BY: 'Last Modified By',
  CAMPAIGN_PLANS_PLAN_LAST_UPDATED: 'Last Modified',
  CAMPAIGN_PLANS_PLAN_PLAYS: 'Plays',
  CAMPAIGN_PLANS_PLAN_STATUS: 'Status',
  CAMPAIGN_SPECIALIST: 'Specialist',
  CREATE_NEW_PLAN: 'Create New Plan',
  EXISTING_PLAN: 'Existing Plan',
  GOT_MESSAGE: 'Got message',
  NO_OPPORTUNITY_LINKED: 'No opportunity linked',
  NO_SF_MAPPING_SUFFIX: '(no opportunity linked)',
  SF_DETAILS_UNAVAILABLE: 'Unavailable',
  SF_DETAILS_UNAVAILABLE_SUFFIX: '(Salesforce details unavailable)',
  SF_DETAILS_UNAVAILABLE_WARNING: "Some Salesforce details couldn't be loaded in time. Refresh the page to try again.",
};

export const AVAILS_PAGE_LABELS = {
  AVAILS: 'Avails',
  END_DATE_FIELD_LABEL: 'End date',
  FRAMES_FIELD_LABEL: 'Frames',
  START_DATE_FIELD_LABEL: 'Start date',
};

export const RESPONSE_STATUS_LABELS = {
  CAMPAIGN_MAINTENANCE: {
    /* eslint-disable sort-keys */
    BOOKING: {
      SUCCESS: {
        TITLE: 'Maintenance plan booked successfully',
        MESSAGE:
          'Your maintenance plan has been booked. The plays you requested are held. You can cancel the plan at any point before it goes live.',
      },
      ERROR: {
        TITLE: 'Booking unsuccessful',
        MESSAGE:
          'We are having trouble booking your plan. As this could be a temporary issue, please try again in a few minutes.',
      },
    },
    CANCELLATION: {
      SUCCESS: {
        MIDFLIGHT: {
          TITLE: 'Dates removed successfully',
          MESSAGE: 'Any frames previously scheduled for future dates have been released from this maintenance plan.',
        },
        PREFLIGHT: {
          TITLE: 'Plan cancelled successfully',
          MESSAGE: 'Your plan has been cancelled and the frames have been released.',
        },
      },
      ERROR: {
        TITLE: 'Cancellation unsuccessful',
        MESSAGE:
          'We are having trouble cancelling your plan. As this could be a temporary issue, please try again in a few minutes.',
      },
    },
    RENEW: {
      SUCCESS: {
        MESSAGE:
          'Your plan was successfully renewed and a new schedule was created. Below is the updated summary. Please note that the plays you requested are not held until the maintenance plan is booked.',
        TITLE: 'Schedule renewed successfully',
      },
    },
    /* eslint-enable sort-keys */
  },
  RENEW: {
    SUCCESS: {
      MESSAGE:
        'V. {version} of your plan was successfully renewed and a new schedule was created. Below is the updated summary. Please note that the frames you have selected are not held until the plan is reserved.',
      TITLE: 'Schedule renewed successfully',
    },
  },
  RESERVATION: {
    SUCCESS: {
      MESSAGE:
        "V. {version} of your plan has been reserved. The frames you've selected are held. You can unreserve the plan at any point before it goes live.",
      TITLE: 'Plan reserved successfully',
    },
  },
  UNRESERVATION: {
    SUCCESS: {
      MESSAGE: 'V. {version} of your plan has been unreserved and the frames have been released.',
      TITLE: 'Plan unreserved successfully',
    },
  },
};

export const ERROR_LABELS = {
  CONNECTION_ISSUE: 'Connection issue',
  ERROR: 'Error',
  ERROR_COPYING: 'Error copying to clipboard',
  ERROR_EXPORTING: 'Error exporting file',
  ERROR_FETCHING_BOOKED_CAMPAIGNS: 'Error fetching booked campaigns',
  ERROR_FETCHING_CAMPAIGNS: 'Error fetching campaigns',
  ERROR_FETCHING_CAMPAIGNS_CONTENT: 'Error fetching campaigns and their content files',
  ERROR_FETCHING_CAMPAIGN_ORDER_LINES: 'Error fetching campaign order lines',
  ERROR_FETCHING_CONTENTS: 'Error fetching contents. Try refreshing the page',
  ERROR_FETCHING_CONTENTS_TITLE: 'Could not get contents',
  ERROR_FETCHING_CONTENT_DETAILS: 'Error fetching content details',
  ERROR_FETCHING_FRAMES_TITLE: 'Could not get frames',
  ERROR_FETCHING_FRAME_DETAILS: 'Error fetching frame details',
  ERROR_FETCHING_FRAME_LIST: 'Error fetching frame list',
  ERROR_FETCHING_FRAME_LISTS: 'Error fetching frame lists',
  ERROR_FETCHING_HISTORY_DATA: 'Error fetching history data',
  ERROR_FETCHING_LINKED_CAMPAIGNS: 'Error fetching linked campaigns. Try refreshing the page',
  ERROR_FETCHING_OPTIONS: 'Error fetching options. Try refreshing the page',
  ERROR_FETCHING_PLANS: 'Error fetching plans',
  ERROR_FETCHING_PRODUCT_CATEGORIES: 'Error fetching product categories. Try refreshing the page',
  ERROR_FETCHING_PRODUCT_CATEGORIES_TITLE: 'Could not get product categories',
  ERROR_FETCHING_PRODUCT_CATEGORY_DETAILS: 'Error fetching product category details',
  ERROR_FETCHING_RULE_DETAILS: 'Error fetching rule details',
  ERROR_MESSAGE: 'An error occurred',
  ERROR_RESTRICTED_ACCESS: 'Restricted access',
  ERROR_RESTRICTED_ACCESS_MESSAGE: 'You do not have access to this page',
  INVALID_EXCLUDED_DAYS: 'Excluded dates must be within the range of the start and end dates',
  INVALID_FRAME_LIST_ID: 'Invalid frame list ID',
  INVALID_RULE_ID: 'Invalid rule ID',
  NOT_FOUND: 'Not found',
  PAGE_NOT_FOUND: 'Page not found',
  PAGE_NOT_FOUND_MESSAGE: 'The page you are looking for does not exist. You will be redirected.',
  PLAN_NOT_FOUND: 'Plan not found',
  QUOTE_LOCKED_ACTION_ERROR_MESSAGE:
    'This quote is currently locked in Salesforce. Please return the Quote Status to Draft in Salesforce, before making changes to this plan.',
  QUOTE_LOCKED_ERROR_TITLE: 'Unlock Quote',
  REAL_TIME_UPDATES_UNAVAILABLE: 'Real-time updates are unavailable',
  SYSTEM_ERROR_MESSAGE: 'Our system is experiencing an issue at the moment. Please wait a few moments and try again.',
  SYSTEM_ERROR_TITLE: 'System Error',
};

export const FOOTER_LABELS = {
  VERSION: 'Version',
};

export const RULES_LABELS = {
  ACCOUNTS: 'Accounts',
  BACK_TO_CONSTRAINTS: 'Back to Constraints',
  BACK_TO_DETAILS: 'Back to details',
  CANNOT_PLAY: ' cannot play ',
  CHANGELOG_INFORMATION: 'Changelog information',
  COMMENT: 'Comment',
  COMMENT_ADDITIONAL_REASONING: 'Enter any additional reasoning behind this change',
  CONSTRAINTS_PAGE_HEADING: 'Constraints',
  CONSTRAINT_NAME_FIELD_LABEL: 'Constraint name',
  CONTENTS: 'Contents',
  CREATE_CONSTRAINT: 'Create constraint',
  DESCRIPTION_FIELD_LABEL: 'Description',
  DESCRIPTION_FIELD_PLACEHOLDER: 'Enter description of the rule',
  DUPLICATE_RULE_NAME_ERROR: 'A constraint with this name already exists. Please choose a unique name',
  EXCEPT_FOR: ' except for ',
  FORM_FRAME_IDS: 'Add frame IDs by pasting them in the box. Separate multiple IDs using commas, spaces or new lines',
  FRAME: 'frame',
  FRAMES: 'frames',
  FRAME_COUNT_ADDED: 'Added',
  FRAME_COUNT_INITIAL: 'Initial',
  FRAME_COUNT_NEW: 'Total',
  FRAME_COUNT_REMOVED: 'Removed',
  FRAME_IDS_FIELD_LABEL: 'Frame IDs',
  FRAME_IDS_HELPER_TEXT:
    'Add frame IDs by pasting them in the box. Separate multiple IDs using commas, spaces or new lines',
  FRAME_LISTS: 'Frame lists',
  LAST_UPDATED: 'Last updated',
  NAME_FIELD_LABEL: 'Name',
  NAME_FIELD_PLACEHOLDER: 'Enter name of the rule',
  NO_FRAMES: 'No frames',
  OPTIONAL_LABEL: '(optional)',
  PRODUCT_CATEGORIES: 'Product categories',
  REASON_FOR_CHANGES_FIELD_LABEL: 'Reason for changes (optional)',
  RULE: 'Rule',
  RULES: 'Rules',
  RULE_ADD_NEW: 'Create',
  RULE_ID: 'Rule ID',
  SECTION_TITLE_CANNOT_PLAY: 'Cannot play',
  SECTION_TITLE_EXCEPT_FOR: 'Except for',
  SECTION_TITLE_FRAMES: 'Frames',
  UPDATE_CONSTRAINT: 'Update constraint',
};

export const FRAME_LISTS_LABELS = {
  BUTTON_ARCHIVE: 'Archive',
  BUTTON_BACK_TO_DETAILS: 'Back to details',
  BUTTON_BACK_TO_FRAME_LISTS: 'Back to frame lists',
  BUTTON_EDIT: 'Edit',
  BUTTON_OPEN_IN_PAGE_VIEW: 'Open in page view',
  BUTTON_VIEW_HISTORY: 'View history',
  CHANGELOG_INFORMATION: 'Changelog information',
  COMMENT: 'Comment',
  COMMENT_ADDITIONAL_REASONING: 'Enter any additional reasoning behind this change',
  CONSTRAINTS: 'Constraints',
  COUNTRY: 'Country',
  CREATE_FRAME_LIST: 'Create frame list',
  CREATE_NEW_FRAME_LIST: 'Create',
  DATE_CREATED: 'Created',
  DATE_LAST_UPDATED: 'Last updated',
  DESCRIPTION: 'Description',
  DUPLICATE_FRAME_LIST_NAME_ERROR: 'A frame list with this name already exists. Please choose a unique name',
  FORM_DESCRIPTION: 'Enter frame list description',
  FORM_FRAME_IDS: 'Add frame IDs by pasting them in the box. Separate multiple IDs using commas, spaces or new lines',
  FORM_NAME: 'Enter frame list name',
  FRAMES: 'Frames',
  FRAMES_LABEL: 'frames',
  FRAME_COUNT: 'Frame count',
  FRAME_COUNT_ADDED: 'Added',
  FRAME_COUNT_INITIAL: 'Initial',
  FRAME_COUNT_NEW: 'Total',
  FRAME_COUNT_REMOVED: 'Removed',
  FRAME_IDS: 'Frame IDs',
  FRAME_LIST: 'Frame list',
  FRAME_LISTS: 'Frame lists',
  FRAME_LISTS_NAME: 'Name',
  FRAME_LIST_ADD_NEW: 'Add new frame list',
  FRAME_LIST_NAME_FIELD_LABEL: 'Frame list name',
  LAST_UPDATED: 'Last updated',
  NONE_APPLIED: 'None applied',
  NO_DESCRIPTION: 'No description available for this frame list',
  OPTIONAL_LABEL: '(optional)',
  REASON_FOR_CHANGES_FIELD_LABEL: 'Reason for changes (optional)',
  SHEET_NAME_FRAME_IDS: 'Frame List Frame IDs',
  UPDATE_FRAME_LIST: 'Update frame list',
};

export const ACCOUNTS_INDEX_LABELS = {
  ACCOUNT: 'Account',
  ACCOUNTS: 'Accounts',
  TYPE: 'Type',
};

export const ACCOUNT_DETAILS_LABELS = {
  ACCOUNT: 'Account',
  ACTIVE: 'Active',
  BUTTON_BACK_TO_ACCOUNTS: 'Back to accounts',
  BUTTON_OPEN_IN_PAGE_VIEW: 'Open in page view',
  CONSTRAINTS: 'Constraints',
  COUNTRY: 'Country',
  FALSE: 'No',
  NONE_APPLIED: 'None applied',
  PRODUCT_CATEGORIES: 'Product categories',
  SALESFORCE_ID: 'Salesforce ID',
  TRUE: 'Yes',
  TYPE: 'Type',
};

export const FRAMES_INDEX_LABELS = {
  AD_UNIT_TYPE: 'Ad unit type',
  APPLY_FILTERS: 'Apply filters',
  CLEAR_FILTERS: 'Clear filters',
  CLEAR_FRAME_ID: 'Clear Frame ID',
  FRAMES: 'Frames',
  FRAME_ID: 'Frame ID',
  FRAME_NOT_FOUND: 'This frame was not found. Please check if it’s correct and try again.',
  GOTO_FRAME: 'Go to frame',
  GOTO_FRAME_ID: 'Go to frame ID',
  LAST_UPDATED: 'Last updated',
  LOCATION: 'Location',
  LOCATION_LEVELS: {
    level1s: 'TV Area',
    level2s: 'Conurbation',
    level4s: 'District',
    level5s: 'City',
  },
  PRODUCT_TYPE: 'Product type',
};

export const PRODUCT_CATEGORIES_INDEX_LABELS = {
  CLEAR_SEARCH: 'Clear search',
  GROUP: 'Group (LVL2)',
  LAST_UPDATED: 'Last updated',
  PRODUCT_CATEGORIES: 'Product categories',
  PRODUCT_CATEGORY: 'Product category (LVL3)',
  SEARCH_LABEL: 'Search product categories',
  THEME: 'Theme (LVL1)',
};

export const PRODUCT_CATEGORY_DETAILS_LABELS = {
  ACCOUNT: 'Account',
  ACCOUNTS: 'Accounts',
  BUTTON_BACK_TO_PRODUCT_CATEGORIES: 'Back to product categories',
  BUTTON_OPEN_IN_PAGE_VIEW: 'Open in page view',
  CONSTRAINTS: 'Constraints',
  FILTER_ACCOUNTS: 'Filter accounts',
  GROUP: 'Group (LVL2)',
  NONE_APPLIED: 'None applied',
  SALESFORCE_ID: 'Salesforce ID',
  SEARCH_ACCOUNTS: 'Search accounts',
  THEME: 'Theme (LVL1)',
};

export const CONTENTS_INDEX_LABELS = {
  CLEAR_SEARCH: 'Clear search',
  CONTENT: 'Content',
  CONTENTS: 'Contents',
  SEARCH_LABEL: 'Search contents',
};

export const CONTENT_DETAILS_LABELS = {
  BUTTON_BACK_TO_CONTENTS: 'Back to contents',
  BUTTON_OPEN_IN_PAGE_VIEW: 'Open in page view',
  CONSTRAINTS: 'Constraints',
  NONE_APPLIED: 'None applied',
};

export const FRAME_DETAILS_LABELS = {
  AD_UNIT_TYPE: 'Ad unit type',
  BUTTON_BACK_TO_FRAMES: 'Back to Frames',
  BUTTON_OPEN_IN_PAGE_VIEW: 'Open in page view',
  CITY: 'City',
  CONSTRAINTS: 'Constraints',
  CONURBATION: 'Conurbation',
  DISTRICT: 'District',
  FRAME_LISTS: 'Frame lists',
  LAST_UPDATED: 'Last updated',
  LOCATION: 'Location',
  NONE_APPLIED: 'None applied',
  POSTCODE: 'Postcode',
  PRODUCT_TYPE: 'Product type',
  TV_AREA: 'TV Area',
  VENUE: 'Venue',
  VENUE_CODE: 'Venue code',
};

export const GENERAL_LABELS = {
  BACK: 'Back',
  BACK_TO_PLAN: 'Back to plan',
  CANCEL: 'Cancel',
  CANCEL_REQUEST: 'Cancel request',
  CHECKING: 'Checking...',
  CHECK_AVAILABILITY: 'Check availability',
  CLICK_TO_COPY: 'Click to copy',
  CLOSE: 'Close',
  COMING_SOON: 'Coming soon',
  CONFIRM: 'Confirm',
  COPIED_TO_CLIPBOARD: 'Copied %s frame IDs to the clipboard',
  COPY_FRAME_IDS: 'Copy frame IDs',
  DELIVERY_METHOD: 'Delivery method',
  ERROR: 'Error',
  EXPORT: 'Export',
  GO_BACK: 'Go back',
  HOME: 'Home',
  LOADING: 'Loading...',
  MORE: 'More',
  NEXT: 'Next',
  NO_CHANGES_TO_APPLY: 'No changes to apply',
  NO_RECORDS_FOUND: 'No records found',
  NO_RESULTS_FOUND: 'No results found',
  OKAY: 'Okay',
  PLAN_SUMMARY: 'Plan summary',
  PREVIOUS: 'Previous',
  PRODUCT: 'Product',
  REFRESH: 'Refresh',
  RELOAD: 'Reload',
  REMOVE: 'Remove',
  RETRY: 'Retry',
  SALESFORCE: 'Salesforce',
  SEARCH_ON_INPUT: 'Start typing... Enter 3 or more characters to search',
  SEARCH_PLACEHOLDER: 'Search...',
  SELECT_PLACEHOLDER: 'Select...',
  SHOWING: 'Showing',
  SKIPPED_DUPLICATE_FRAME_IDS: 'Skipped %s duplicate(s)',
  SUBMIT: 'Submit',
  SUBMITTING: 'Submitting...',
  SUCCESS: 'Success',
  SUCCESSFUL_EXPORT: 'Successful export',
  THIS_ACTION_IS_NOT_REVERSIBLE: 'This action is not reversible.',
  UNKNOWN_USER: 'Unknown user',
  VIEW: 'View',
  WARNING: 'Warning',
};

export const HEADER_LABELS = {
  AVATAR_TOOLTIP: 'Open user menu',
  CAMPAIGNS: 'Campaigns',
  NOTIFICATIONS: 'Notifications',
  SECRET_PATH: 'Secret Path',
  SIGN_IN: 'Sign in',
  SIGN_OUT: 'Sign out',
  UNKNOWN_INITIALS: 'ID',
};

export const HOME_PAGE_LABELS = {
  WELCOME: 'Welcome',
};

export const SITE_LABELS = {
  BM_COPYRIGHT_LABEL: `© Bauer Media Outdoor ${new Date().getFullYear()}`,
  SITE_DESCRIPTION: 'AdAstra',
  SITE_TITLE: 'AdAstra',
};

export const BANNER_LABELS = {
  CAMPAIGN_MAINTENANCE_PLAN: 'Maintenance plan',
  NON_GUARANTEED_PLAN: 'Non-guaranteed plan',
};

export const NOTIFICATION_LABELS = {
  CAMPAIGN_MAINTENANCE: {
    PLAN_ALREADY_BOOKED: {
      MESSAGE: 'This maintenance plan is already being booked. Please refresh the page to see changes.',
      TITLE: 'Refresh to see changes - plan booking is already requested',
    },
    PLAN_ALREADY_CANCELLED: {
      MESSAGE: 'This maintenance plan is already being cancelled. Please refresh the page to see changes.',
      TITLE: 'Refresh to see changes - plan cancellation is already requested',
    },
    PLAN_RENEWED_EXTERNALLY: {
      MESSAGE: 'This plan has been updated. Please refresh the page to see the updated summary.',
      TITLE: 'Refresh to see the latest version of the plan.',
    },
  },
  FRAME_SWAP: {
    PARTIAL_SWAP: {
      MESSAGE:
        'A swap has been performed on this plan only for overlapping days, which could have altered the distribution on each day to create averages. Please check the campaign integrity before making any changes.',
      TITLE: 'Swaps performed on this plan - check for Averages distribution',
    },
  },
};

export const MIGRATED_PLAN_BANNER_LABELS = {
  FIXED: {
    BULLETS: [
      'Please check if criteria was added correctly before making any changes.',
      'If making swaps, please reach out to a colleague from the sales planning team, with Advanced permissions.',
      'If running Campaign Maintenance on Booked plans, please be aware that constraints may not be applied automatically and frames should be excluded manually.',
    ],
    INTRO: 'This plan was migrated from a legacy system:',
  },
  NON_GUARANTEED: {
    MESSAGE:
      'This plan was migrated from a legacy system. Please check if criteria was added correctly before making any changes.',
  },
  TITLE: 'Migrated plan',
};

export const PLAN_FORM_LABELS = {
  ADDITIONAL_FRAME: 'additional frame',
  ADDITIONAL_FRAMES: 'additional frames',
  ADDITIONAL_FRAMES_FIELD_HELPER_TEXT:
    'We will add frames chosen from original plan criteria (ie. locations, malls, etc) dependent on availability.',
  AD_DURATION_FIELD_LABEL: 'Ad duration',
  ALLOW_AVERAGES_FIELD_LABEL: 'Allow averages (optional)',
  ALL_FRAMES_FIELD_LABEL: 'All frames',
  AMOUNT_OF_FRAMES_FIELD_EXCEEDS_MAXIMUM: 'There are not enough frames available to meet your requirements',
  AMOUNT_OF_FRAMES_FIELD_REQUIRED: 'Please enter a number greater than 0',
  AUTOMATED_CONSTRAINTS_FIELD_LABEL: 'Automated constraints',
  AUTOMATED_CONSTRAINTS_FIELD_TOOLTIP_LABEL:
    'Automated constraints are applied based on the product categories and accounts associated with the campaign in Salesforce. Only advanced users can remove these. You can add manual constraints below.',
  COPY_PASTE: 'Copy/paste',
  DATES_FIELD_REQUIRED: 'Please select at least one date',
  DATE_IN_NEXT_TWO_YEARS_VALIDATION: 'Date must be in the next 2 years',
  DATE_VALID_VALIDATION: 'Please enter a valid date',
  DISTRIBUTION_TOGGLE_OPTION_GENERAL: 'General',
  DISTRIBUTION_TOGGLE_OPTION_SPECIFIC: 'Specific',
  DISTRIBUTION_TOGGLE_OPTION_WEIGHTED: 'Weighted',
  END_DATE_FIELD_LABEL: 'End date',
  END_DATE_FIELD_REQUIRED: 'Please enter the end date',
  EXISTING_FRAMES_FIELD_HELPER_TEXT:
    'We will increase share of time on existing plan frames, dependent on availability.',
  EXISTING_FRAMES_FIELD_LABEL: 'Existing frames',
  EXPORT: 'Export',
  EXPORT_DETAILS: 'Export a list of non-usable frames with reasons for unsuitability',
  FORMAT_FIELD_LABEL: 'Format',
  FORMAT_FIELD_REQUIRED: 'Please select at least one format',
  FORM_SECTION_HEADING_DATES: 'Dates',
  FORM_SECTION_HEADING_DATE_RANGE: 'Date range',
  FORM_SECTION_HEADING_EXCLUDE: 'Exclude',
  FORM_SECTION_HEADING_EXCLUDE_FROM_TOP_UP: 'Exclude from top up',
  FORM_SECTION_HEADING_PICK_DAYS: 'Pick days',
  FORM_SECTION_HEADING_PICK_HOURS: 'Pick hours',
  FORM_SECTION_HEADING_SELECT: 'Select',
  FORM_SECTION_HEADING_TARGET_GOAL: 'Target goal',
  FORM_SECTION_HEADING_TOP_UP: 'Top up',
  FRAME: 'frame',
  FRAMES: 'frames',
  FRAMES_EXCLUDED_CHIP_LABEL: 'frames excluded',
  FRAMES_INCLUDED_CHIP_LABEL: 'frames included',
  FRAME_IDS_CLEAR_INVALID: 'Clear invalid frames',
  FRAME_IDS_CLEAR_UNUSABLE: 'Clear non-usable frames',
  FRAME_IDS_COPY_INVALID: 'Copy invalid frame IDs',
  FRAME_IDS_FIELD_HELPER_TEXT: 'Copy/paste frame IDs. Separate them using commas, spaces or new lines.',
  FRAME_IDS_FIELD_LABEL: 'Frame IDs',
  FRAME_IDS_FIELD_REQUIRED: 'Please enter at least one frame id',
  FRAME_IDS_GENERAL_VALIDATION: 'One or more frame IDs are invalid',
  FRAME_IDS_INVALID_MESSAGE: 'Some of the included frames are invalid',
  FRAME_IDS_ONLY_FIELD_LABEL: 'Frame IDs (Include only)',
  FRAME_IDS_ONLY_FIELD_TOOLTIP_LABEL: 'Copy multiple frame IDs and paste them here. They will all be added in one go.',
  FRAME_IDS_ONLY_OR_LOCATIONS_REQUIRED: 'Frame IDs (Include only) or Locations is required and cannot be combined',
  FRAME_IDS_OPTIONAL_FIELD_LABEL: 'Frame IDs (optional)',
  FRAME_IDS_TOGGLE_OPTION_BUTTON: 'Frame IDs',
  FRAME_IDS_UNUSABLE_MESSAGE: 'Some of the selected frames cannot be used',
  FRAME_ID_MAX_VALIDATION: 'Frame ID must be at most 10 digits',
  FRAME_UNIVERSE_EXCLUDED: 'excluded',
  FRAME_UNIVERSE_INCLUDED: 'included',
  HOURLY_DISTRIBUTION: 'Hourly distribution',
  HOURS_AM_COMMUTER_VALUE_OPTION_LABEL: 'AM Commuter',
  HOURS_AM_LABEL: 'AM',
  HOURS_ENTERTAINER_VALUE_OPTION_LABEL: 'Entertainer',
  HOURS_FIELD_LABEL: 'Hours per day',
  HOURS_FIELD_REQUIRED: 'Please select at least one hour',
  HOURS_FULL_DAY_LABEL: 'Full day',
  HOURS_OFF_PEAK_VALUE_OPTION_LABEL: 'Off Peak',
  HOURS_PM_COMMUTER_VALUE_OPTION_LABEL: 'PM Commuter',
  HOURS_PM_LABEL: 'PM',
  HOURS_RETAIL_VALUE_OPTION_LABEL: 'Retail',
  INCLUDE_ASDA_LIVE_NORTHERN_IRELAND: 'Include Asda Live Northern Ireland',
  I_WOULD_ALSO_LIKE_TO_AIM_FOR: 'I would also like to aim for',
  LOCATIONS_EXCLUDE_LOCATIONS_FIELD_LABEL: 'Locations (optional)',
  LOCATIONS_FIELD_LABEL: 'Locations',
  LOCATIONS_FIELD_REQUIRED: 'Please select at least one location',
  LOCATIONS_OR_FRAME_IDS_REQUIRED: 'Please provide at least one location or Frame ID',
  LOCATIONS_TOGGLE_OPTION_BUTTON: 'Locations',
  MALLS: 'Malls',
  MALLS_FIELD_REQUIRED: 'Please select at least one mall',
  MALLS_PREFERRED_FIELD_REQUIRED: 'Please enter at least one preferred mall',
  MANUAL_CONSTRAINTS_FIELD_LABEL: 'Manual constraints (optional)',
  MANUAL_CONSTRAINTS_VIEW_ALL_LINK: 'View all constraints',
  MAX: 'Max (optional)',
  MAX_PLAYS_FIELD_LABEL: 'Max plays (optional)',
  MAX_PLAYS_FIELD_TOOLTIP: 'This sets the maximum amount of times the campaign can play. Leave empty for no limit',
  MAX_PLAYS_FIELD_VALIDATION_TOO_BIG:
    'Please enter a number no greater than 1,000,000,000 (or leave empty for no limit)',
  MAX_PLAYS_FIELD_VALIDATION_TOO_SMALL: 'Please enter a number greater than 0',
  MIN: 'Min (optional)',
  NEW_PLAN: 'New plan',
  NON_GUARANTEED: 'Non-guaranteed',
  NO_AUTOMATED_CONSTRAINTS: 'No automated constraints applied',
  OFF_PEAK: 'Off-peak (5am - 6am, 10am - 4pm, 8pm - 12am)',
  OVERRIDE_SPECIFIC_DISTRIBUTION_FIELD_HELPER_TEXT:
    'Original plan has a specific distribution applied, which may limit choices based on availability. If you override, we will apply general distribution instead.',
  PEAK: 'Peak (6am - 10am, 4pm - 8pm)',
  PERCENTAGE_UNIT_LABEL: '%',
  PLAYS_FIELD_LABEL: 'Plays',
  PLAYS_FIELD_VALIDATION_TOO_SMALL: 'Please enter a number greater than 0.',
  PLEASE_ENTER_PLAYS: 'Please enter plays',
  PREEMPTIBLE_FIELD_LABEL: 'Type',
  PREEMPTIBLE_FIELD_VALIDATION: 'Please select a type',
  PREFERRED_FRAME: 'preferred frame',
  PREFERRED_FRAMES: 'preferred frames',
  PRIMARY_GOAL_FIELD_LABEL: 'Primary Goal',
  PRIMARY_GOAL_FIELD_REQUIRED: 'Primary goal is required',
  PRIMARY_SECONDARY_GOALS_SAME_INVALID: 'Primary and secondary goals cannot be the same',
  QUANTITY_FIELD_REQUIRED: 'Please enter a number within range',
  QUANTITY_UNIT_LABEL: 'Plays',
  REGIONS: 'Regions',
  REMOVE_SAME_VENUE_DUPLICATES_FIELD_LABEL: 'Remove same-venue duplicates (optional)',
  SCREENS_PER_DAY_FIELD_LABEL: 'Frames per day', // Note: keep this key name as 'SCREENS_PER_DAY_...', and the string value as 'Frames ...'
  SEARCH: 'Search',
  SEARCH_OR_COPY_PASTE: 'Search or copy/paste',
  SECONDARY_GOAL_FIELD_LABEL: 'Secondary Goal',
  SECONDARY_GOAL_FIELD_REQUIRED: 'Secondary goal is required',
  SECONDS: 'sec',
  SHARE_OF_TIME_FIELD_LABEL: 'Share of time',
  SHARE_OF_TIME_INVALID: 'Must be a value between 1% and 100%',
  SHARE_OF_TIME_OTHER_LABEL: 'Other',
  SHARE_OF_TIME_OTHER_REQUIRED: 'Please use an option or fill in a value between 1% and 100%',
  SPARES_FIELD_LABEL: 'Spares (optional)',
  SPECIFIC_AMOUNT_OF_FRAMES_FIELD_REQUIRED: 'Please enter a number',
  // SPECIFIC_DISTRIBUTION_FIELDS_INVALID: 'All specific distribution fields must be valid', // ToDo - DPD-1580 - when removing "Frames per day" field for "Specific" distribution, uncomment this line
  SPECIFIC_DISTRIBUTION_TOTAL_FRAME_COUNT_DOES_NOT_MATCH:
    'Please make sure the sum of the frames below matches the total frames per day',
  START_DATE_FIELD_LABEL: 'Start date',
  START_DATE_FIELD_REQUIRED: 'Please enter the start date',
  START_DATE_NOT_AFTER_END_DATE_VALIDATION: "Start date can't be after end date",
  START_DATE_VALIDATION_18_MONTHS: 'Date must be within 18 months',
  STATIONS: 'Stations',
  STATIONS_PREFERRED_FIELD_REQUIRED: 'Please enter at least one preferred station',
  TV_AREAS: 'TV Areas',
  VENUE_CODES_FIELD_HELPER_TEXT: 'Copy a list of venue codes and paste here',
  VENUE_CODES_PREFERRED_FIELD_REQUIRED: 'Please enter at least one preferred venue code ',
  VENUE_CODES_PREFERRED_LIST_FIELD_LABEL: 'Preferred venue codes',
  VENUE_CODES_TOGGLE_OPTION_BUTTON: 'Venue codes',
  VENUE_CODES_WIDER_LIST_FIELD_LABEL: 'Additional venue codes (optional)',
  VENUE_CODE_CLEAR_INVALID: 'Clear invalid venue codes',
  VENUE_CODE_GENERAL_VALIDATION: 'One or more venue codes are invalid',
  VENUE_NAME_PREFERRED_LIST_FIELD_LABEL: 'Preferred {productName}',
  VENUE_NAME_WIDER_LIST_FIELD_LABEL: 'Additional {productName} (optional)',
  WEIGHTED_DISTRIBUTION_FIELDS_INVALID: 'All weighted distribution fields must be valid',
  WEIGHTED_DISTRIBUTION_MAXIMUM_FIELDS_INVALID: 'Please make sure the sum of maximum percentages is not less than 100%',
  WEIGHTED_DISTRIBUTION_MINIMUM_FIELDS_INVALID: 'Please make sure the sum of minimum percentages is not more than 100%',
  WEIGHTED_DISTRIBUTION_PAIR_INVALID: "Minimum percentage can't be more than maximum percentage",
  WHAT: 'What',
  WHAT_FRAMES_INFO_DESCRIPTION:
    'We allow a max amount of frames based on your selected locations. For a higher number, please go back a step and add more locations.',
  WHAT_FRAMES_INFO_TITLE: "Why can't I choose more frames?",
  WHAT_SECTION_AVERAGES_DISABLED_TOOLTIP: 'Averages cannot function alongside specific distribution',
  WHEN: 'When',
  WHERE: 'Where',
  WHERE_SECTION_AT_LEAST_ONE_REQUIRED_MESSAGE:
    'At least one of Frame IDs, Location Filters, or Venue codes or Venue names must have a value',
  WHERE_SECTION_DISABLED_TOGGLE_OPTION_BUTTON_TOOLTIP: 'Remove all {fieldToRemove} to input {fieldToInput} instead',
  WHERE_SECTION_LOCATION_DISABLED_OPTION_TOOLTIP: 'Remove other locations to input this one instead',
  WHERE_VENUE_CODES_OR_FRAME_IDS_REQUIRED: 'Please provide at least one Venue code or Frame ID',
};

export const PLAN_FORM_SUMMARY_LABELS = {
  CHIP_TEXT_CAMPAIGN_MAINTENANCE_FRAMES: 'frames',
  CHIP_TEXT_CAMPAIGN_MAINTENANCE_SHARE_OF_TIME: 'share of time',
  CHIP_TEXT_DAY: 'day',
  CHIP_TEXT_DAYS: 'days',
  CHIP_TEXT_INCREASING: 'increasing',
  CHIP_TEXT_PLAY: 'play',
  CHIP_TEXT_PLAYS: 'plays',
  CHIP_TEXT_POSSIBLE_FRAME: 'possible frame',
  CHIP_TEXT_POSSIBLE_FRAMES: 'possible frames',
  CHIP_TEXT_SCREENS_PER_DAY: 'frames per day', // Note: keep this key name as '..._SCREENS_PER_DAY', and the string value as 'frames per day'
  CHIP_TEXT_SEC: 'sec',
  CHIP_TEXT_SHARE_OF_TIME: 'share of time',
  CHIP_TEXT_SPARES: 'spares',
  CONJUNCTION_TEXT_AT: 'at',
  CONJUNCTION_TEXT_BY: 'by',
  CONJUNCTION_TEXT_OUT_OF: 'out of',
  CONJUNCTION_TEXT_OVER: 'over',
  CONJUNCTION_TEXT_PLUS_AN_ADDITIONAL: 'plus an additional',
  HEADING_AIM_FOR: 'We will aim for',
  HEADING_CONSIDER: 'We will consider',
  INFORMATION_DESCRIPTION:
    "We will always aim to fulfil your request across the same screens each day, with an even distribution across locations and availability. If there's no availability, we will show you the closest possible match.",
  INFORMATION_TITLE: "What if this isn't possible?",
};

export const NEW_PLAN_PAGE = {
  BACK_TO_CAMPAIGNS: 'Back to Campaigns',
  RE_USE_FRAMES_INFORMATION:
    'An amendment is in progress and some frames will be released from the following Booked versions. Do you want the system to prioritise those frames when checking availability for this plan? This will only apply to frames still matching new criteria and does not guarantee all frames will be included in the new plan',
  RE_USE_FRAMES_NO_BUTTON: 'No, close this',
  RE_USE_FRAMES_TITLE: 'Prioritise frames from another plan?',
  RE_USE_FRAMES_YES_BUTTON: 'Yes, prioritise frames',
  RE_USE_SUCCESS_MESSAGE:
    'If it matches your requested criteria, the system will prioritise using frames from the plan you selected.',
  RE_USE_SUCCESS_TITLE: 'Frames will be re-used',
  SELECT_MISSING_VALUES: 'Select missing values',
};

export const PLAN_DETAILS_PAGE_LABELS = {
  AD_DURATION_DESCRIPTION_LABEL: 'ad duration',
  AD_DURATION_SECONDS_LABEL: 'sec',
  AMEND: 'Amend',
  AMEND_QUOTE_LOCKED_MESSAGE: {
    BEFORE: 'Please go through ',
    BOLD: 'Amend order',
    // eslint-disable-next-line sort-keys
    AFTER: ' in Salesforce before starting the amendments process in AdAstra.',
  },
  AMEND_QUOTE_LOCKED_WARNING: 'Go through Salesforce - quote is locked.',
  AVERAGES_DISTRIBUTION: 'averages distribution',
  BOOK: 'Book',
  BOOKING_PLAN_IN_PROGRESS_MESSAGE: 'We are booking your plan...',
  CAMPAIGN_MAINTENANCE: 'Campaign maintenance',
  CAMPAIGN_MAINTENANCE_BOOK: 'Book maintenance',
  CAMPAIGN_MAINTENANCE_BOOK_CONFIRMATION: 'Would you like to book this campaign maintenance plan?',
  CAMPAIGN_MAINTENANCE_CANCELLED_PARENT_WARNING: {
    MESSAGE:
      "There are some Booked campaign maintenance plans in the list below. These will keep running until they're manually cancelled. Please ensure this action is taken by you or a colleague with the right permissions.",
    TITLE: 'Cancel maintenance plans',
  },
  CAMPAIGN_MAINTENANCE_CANCELLING_PLAN_IN_PROGRESS_MESSAGE: {
    MIDFLIGHT: 'We are removing future dates from your plan. These frames will be released...',
    PREFLIGHT: 'We are cancelling your plan. The frames in this plan will be released...',
  },
  CAMPAIGN_MAINTENANCE_CANCEL_CONFIRMATION: {
    MIDFLIGHT: {
      /* eslint-disable sort-keys */
      WARNING_MESSAGE: "Your maintenance plan is Live. You won't be able to undo this action.",
      FIRST_SENTENCE:
        'This action will only cancel the remaining days of this maintenance schedule, starting tomorrow.',
      SECOND_SENTENCE: 'Would you like to remove those dates?',
      CANCEL_BUTTON: 'Remove dates',
      /* eslint-enable sort-keys */
    },
    PREFLIGHT: {
      /* eslint-disable sort-keys */
      WARNING_MESSAGE: GENERAL_LABELS.THIS_ACTION_IS_NOT_REVERSIBLE,
      FIRST_SENTENCE: 'Would you like to move this campaign maintenance plan to Cancelled?',
      SECOND_SENTENCE: 'You can re-create this maintenance plan later, if needed.',
      CANCEL_BUTTON: 'Cancel maintenance plan',
      /* eslint-enable sort-keys */
    },
  },
  CAMPAIGN_MAINTENANCE_CHILD_PLANS_TABLE_HEADER: 'Campaign maintenance plans',
  CAMPAIGN_MAINTENANCE_DISABLED_TOOLTIP: 'This plan is in the past and can no longer be modified.',
  CANCEL: 'Cancel',
  CANCEL_ALREADY_BOOKED_FRAMES_REMAIN_BOOKED:
    'Already booked frames remain booked until you confirm this amendment in Salesforce.',
  CANCEL_CONFIRMATION: 'Do you wish to move this plan to Cancelled?',
  CANCEL_MAINTENANCE: 'Cancel maintenance',
  NEW_CAMPAIGN_MAINTENANCE_PLAN: 'New maintenance plan',
  // eslint-disable-next-line sort-keys
  CONSTRAINTS_AUTOMATED: 'Automated constraints',
  CONSTRAINTS_MANUAL: 'Manual constraints',
  CONSTRAINTS_NONE_APPLIED: 'None applied',
  CREATION_PLAN_IN_PROGRESS_MESSAGE: 'We are creating your plan and schedule...',
  DAILY_FRAMES: 'Daily frames',
  DATES: 'Dates',
  DATES_ACHIEVED_WARNING_MESSAGE:
    'Due to limited availability and average distribution, frames could not be allocated evenly across the full requested date range. Delivery will occur between {achievedStart} – {achievedEnd}, rather than the requested {requestedStart} – {requestedEnd}.',
  DATES_ACHIEVED_WARNING_TITLE:
    'Review delivery dates - achieved delivery period differs from the requested campaign dates',
  DATES_AVG_HOURS_LABEL: 'Hours',
  DATES_AVG_HOURS_UNIT_HOURS_LABEL: 'hour(s)',
  DATES_AVG_HOURS_UNIT_LABEL: 'daily',
  DATES_AVG_HOURS_UNIT_MINUTES_LABEL: 'minute(s)',
  DATES_DAYS_REQUESTED_LABEL: 'Days',
  DATES_DURATION_LABEL: 'Duration',
  DATES_DURATION_UNIT_LABEL: 'days',
  DATES_END_LABEL: 'End',
  DATES_EXCLUDED_ALL_WEEKDAYS: 'All weekdays (Mon–Fri)',
  DATES_EXCLUDED_ALL_WEEKENDS: 'All weekends (Sat & Sun)',
  DATES_EXCLUDED_EVERY_PREFIX: 'Every',
  DATES_EXCLUDED_LABEL: 'Excluding',
  DATES_REQUESTED_PREFIX: 'requested',
  DATES_START_LABEL: 'Start',
  DATE_RANGE_LABEL: 'Date range',
  DELIVERED: 'Delivered',
  EDIT: 'Edit',
  EDIT_DISABLED_TOOLTIP: 'This plan is in the past and can no longer be edited.',
  EXPORT: 'Export',
  EXPORT_DETAILS_COMPLETED: 'Completed',
  EXPORT_DETAILS_IN_PROGRESS: 'Preparing...',
  EXPORT_PLAN_FAILED: 'Plan export failed',
  EXPORT_PLAN_FORMAT_OPTION_WITHOUT_SCHEDULE: 'Export without schedule',
  EXPORT_PLAN_FORMAT_OPTION_WITH_SCHEDULE: 'Export with schedule',
  EXPORT_PLAN_FORMAT_QUESTION: 'Which format would you like to export?',
  EXPORT_PLAN_SUCCESS: 'Plan exported',
  FRAME_BY_FRAME_TABLE: {
    /* eslint-disable sort-keys */
    TOOLBAR: {
      BUTTON: {
        CLEAR_RESULTS: {
          LABEL: 'Clear results',
        },
        VERIFY_FRAMES: {
          DISABLED_TOOLTIP: 'This plan is in the past and can no longer be modified.',
          LABEL: 'Verify frames',
        },
      },
      ICON_BUTTON: {
        COLUMNS: {
          TOOLTIP: 'Columns',
        },
        FILTERS: {
          TOOLTIP: 'Filters',
        },
        EXPORT: {
          TOOLTIP: 'Export',
          MENU_OPTION: {
            EXPORT_CSV: 'Download as CSV',
          },
        },
        SEARCH: {
          INPUT_PLACEHOLDER: 'Search...',
          TOOLTIP: 'Search',
        },
      },
    },
    DATA_GRID: {
      TOOLTIP: {
        TOC: 'Temp. out-of-charge:',
        POC: 'Perm. out-of-charge:',
      },
      TABLE_FILTERS: {
        HEALTHY: 'Healthy',
        TOC: 'Temp. out-of-charge',
        POC: 'Perm. out-of-charge',
      },
    },
    OVERVIEW: {
      TOC: 'Temp. out-of-charge period:',
      POC: 'Perm. out-of-charge from:',
    },
    VERIFYING_SCHEDULE_FRAME_OUT_OF_CHARGE_STATUS: 'Checking your frames for in-charge or out-of-charge status...',
    /* eslint-enable sort-keys */
  },
  INCLUDES_SPARES: 'includes spares',
  LINK: 'Link',
  LOCK_FRAMES: 'Lock frames',
  LOCK_FRAMES_CONFIRMATION: 'Are you sure you want to lock these frames?',
  LOCK_FRAMES_WARNING:
    'These frames will not be swapped by other campaigns. We recommend doing this only if essential, such as when sending upsites, since it makes inventory management more difficult.',
  MAIN_PLAN: 'Main plan',
  MAX_PLAYS: 'Max plays (optional)',
  MIDFLIGHT_DESCRIPTION:
    'You can only change the end date on live plans. Any past dates cannot be amended and will be retained. To change any other criteria, please create a new plan in Salesforce.',
  MIDFLIGHT_INFO: 'Your plan is Live',
  NON_GUARANTEED: 'Non-guaranteed',
  NO_MAXIMUM: 'No maximum',
  NO_SWAPS: 'No swaps',
  NUMBER_OF_FRAMES_INFO: 'No. of Frames',
  NUMBER_OF_PLAYS_INFO: 'Plays',
  OK_FOR_SWAPS: 'OK for swaps',
  PLAN_HAS_BEEN_CANCELLED: 'This plan have successfully been cancelled',
  PLAN_HAS_BEEN_UPDATED: 'This plan has been updated. Please refresh your page.',
  PLAN_HAS_BEEN_UPDATED_CLEAR_ERRORS: 'This plan has been updated. Refresh your page to clear errors.',
  PLAN_HAS_BEEN_UPDATED_OTHER_VERSION: 'There has been an update in another version of this plan',
  PLAN_IN_THE_PAST_TOOLTIP: 'This plan is in the past and can no longer be changed.',
  PLAN_NOT_SWAPPABLE: 'Frames locked',
  PLAN_STATUS_HAS_BEEN_UPDATED: 'This plan status been updated',
  PLAN_SWAPPABLE: 'Frames unlocked',
  PLAYS: 'Plays',
  PREEMPTIBLE: 'Preemptible',
  PRE_RESERVATION: "You're about to reserve these frames.",
  QUOTE_LOCKED_TOOLTIP: 'Locked quote in Salesforce',
  RENEW: 'Renew',
  REPLACE: 'Replace',
  REPLACE_RESERVATION: 'Replace reservation',
  REQUESTED: 'requested',
  RESERVE: 'Reserve',
  RESERVE_ALREADY_RESERVED: 'It seems this plan already has a reservation',
  RESERVE_BUTTON_DISABLED_MISSING_QUOTE_LINE: 'The plan has no associated quote line in Salesforce',
  RESERVE_BUTTON_DISABLED_PLAN_END_DATE_IN_PAST: 'The plan end date is in the past',
  RESERVE_BUTTON_DISABLED_PLAN_START_DATE_IN_PAST: 'The plan start date is in the past',
  RESERVE_BUTTON_DISABLED_RESERVATION_REQUESTED_CURRENT_VERSION:
    'Reservation for this plan version is already requested',
  RESERVE_BUTTON_DISABLED_RESERVATION_REQUESTED_OTHER_VERSION:
    'Reservation for another plan version is already requested',
  RESERVE_BUTTON_DISABLED_SCHEDULE_CREATED_WITH_NO_FRAMES: 'Plan must contain frames before it can be reserved',
  RESERVE_BUTTON_DISABLED_SCHEDULE_CREATION_IN_PROGRESS: 'Schedule must be created successfully before reservation',
  RESERVE_CONFIRMATION: 'Would you like to reserve these frames?',
  RESERVE_INFO:
    ' Please let us know if these cannot be swapped later, due to dynamic content, specific frames requested by client, or any other reason.',
  RESERVE_UNAVAILABLE_FRAMES_MESSAGE:
    'Please renew availability before reserving or go back and edit your plan to include more frames.',
  RESERVE_UNAVAILABLE_FRAMES_WARNING: 'It seems that some frames are no longer available.',
  RESERVE_UNRESERVE_REPLACE_1: 'Would you like to unreserve',
  RESERVE_UNRESERVE_REPLACE_2: 'and replace it with this version instead?',
  SAME_FRAMES: 'Same frames each day',
  SEARCH_BAR_TEXT: 'Search frame, ID, location...',
  SHARE_OF_TIME_TOTAL: 'Share of time',
  SHEETS_AVAILABLE: 'Sheets available for inclusion',
  SHEETS_DOWNLOAD_SELECTED: 'Download selected',
  SHEETS_DOWNLOAD_SELECT_AT_LEAST_ONE: 'Please select at least one sheet to proceed with your download',
  SHEET_NAME_DAILY_DISTRIBUTION: 'Daily Distribution',
  SHEET_NAME_FRAME_BY_FRAME: 'Frame by Frame',
  SHEET_NAME_LOCATION_DISTRIBUTION: 'Location Distribution',
  SHEET_NAME_SCHEDULE: 'Schedule',
  SHEET_NAME_SITE_LIST: 'Site List',
  SHOW_LESS: 'Show less',
  SHOW_X_MORE: 'Show X more',
  SPARE: 'spare',
  SPARES: 'spares',
  STATUS: 'Status',
  SWAP_FRAMES: 'Swap frames',
  SWITCH: 'Switch',
  TABLE_HEADER_DISTRIBUTION_LOCATION: 'Distribution by location',
  TABLE_HEADER_DISTRIBUTION_TIME: 'Distribution by day/hour',
  TABLE_HEADER_FRAME_BY_FRAME: 'Frame by frame',
  UNIQUE_FRAMES: 'Unique frames',
  UNLOCK_FRAMES: 'Unlock frames',
  UNLOCK_FRAMES_CONFIRMATION: 'You are allowing these frames to be swapped by other campaigns.',
  UNLOCK_FRAMES_WARNING: 'Are you sure you want to unlock these frames?',
  UNRESERVE: 'Unreserve',
  UNRESERVE_BUTTON_DISABLED_SCHEDULE_NOT_RESERVED: 'Only reserved plans can be unreserved',
  UNRESERVE_CONFIRMATION: 'Would you like to unreserve these frames?',
  USER: 'User',
  WARNING_LOW_AVAILABILITY:
    "The available frames are added to your plan. If you'd like to include more, you can edit the plan to update your criteria.",
  WARNING_LOW_AVAILABILITY_CM:
    "The available plays are added to your plan. If you'd like to include more, you can set up another maintenance plan to update your criteria.",
  WARNING_LOW_AVAILABILITY_CM_TITLE: 'Not all requested plays were delivered',
  WARNING_LOW_AVAILABILITY_TITLE: 'Not all requested frames were available',
  WEIGHTED_DISTRIBUTION_FRAME_GOAL_NOT_MET_MESSAGE:
    'The overall frame goal could not be achieved. Each individual area met its weighted distribution range, but the total frames delivered are below the overall target. This may be due to inventory availability or plan configuration. You can swap frames from another campaign or edit the plan criteria.',
  WEIGHTED_DISTRIBUTION_FRAME_GOAL_NOT_MET_TITLE: 'Frame goal not fully achieved',
};

export const PLAN_DETAIL_INFO_ASIDE_LABELS = {
  ADVERTISER: 'Advertiser',
  AGENCY: 'Agency',
  CAMPAIGN_NAME: 'Campaign Name',
  PRODUCT: 'Product',
  SALESPERSON: 'Salesperson',
  SPECIALIST: 'Specialist',
};

export const PLAN_SUMMARY_TABLE_HEADERS = {
  CITY: 'City',
  CONURBATION: 'Conurbation',
  DISTRICT: 'District',
  FRAME_ID: 'Frame ID',
  FRAME_STATUS: 'Frame status',
  OUT_OF_CHARGE_DATES: 'OOC Date(s)',
  PLAYS: 'Plays',
  POSTCODE: 'Postcode',
  SHARE_OF_TIME: 'Share of time',
  TV_AREA: 'TV area',
  VENUE_CODE: 'Venue code',
  VENUE_NAME: 'Venue name',
};

export const PLAN_REUSED_FRAMES_PROMPT_LABELS = {
  DAILY_FRAMES: 'Daily frames',
  DATE_RANGE: 'Dates',
  PLAN: 'Plan',
  PLAYS: 'Plays',
  SHARE_OF_TIME: 'Share of time',
  VERSION: 'Version',
};

export const CHART_AND_TABLE_LABELS = {
  AVERAGE_DAILY_FRAME: 'Average daily frame',
  AVERAGE_DAILY_FRAMES: 'Average daily frames',
  CHART: 'Chart',
  CITIES: 'Cities',
  CONURBATIONS: 'Conurbations',
  DAILY_FRAMES: 'Daily frames',
  DATE: 'Date',
  DAYS: 'Days',
  DISTRIBUTION_BY_LOCATION: 'Distribution by location',
  DISTRIBUTION_BY_TIME: 'Distribution by day/hour',
  DISTRICTS: 'Districts',
  EXPORT_CURRENT_VIEW: 'Export current view',
  EXPORT_MULTIPLE_EXPLANATION: 'For multiple views at once, use the Export button at the top of the page instead',
  FRAMES: 'Frames',
  FRAMES_TOTAL: 'Frames total',
  FRAME_IDS: 'Frame IDs',
  FRAME_TOTAL: 'Frame total',
  HOURS: 'Hours',
  INCLUDE_UNSPECIFIED: 'Include unspecified',
  NO_DATA: 'No data',
  PLAYS: 'Plays',
  PLAYS_TOTAL: 'Plays total',
  PLAY_TOTAL: 'Play total',
  QTY: 'Qty',
  TABLE: 'Table',
  TOTAL: 'Total',
  TOTAL_UNIQUE_FRAME: 'Total unique frame',
  TOTAL_UNIQUE_FRAMES: 'Total unique frames',
  TV_AREAS: 'TV Areas',
  UNIQUE_FRAMES: 'Unique frames',
  UNSPECIFIED: 'Unspecified',
  VENUES: 'Venues',
};

export const PLAN_ALERT_LABELS = {
  LONGER_THAN_EXPECTED: 'This is taking longer than expected. Try reloading the page.',
  NO_AVAILABLE_FRAMES_DESCRIPTION:
    'There are no available frames based on your criteria and dates. You can swap frames from another campaign or edit the plan to update your criteria.',
  NO_AVAILABLE_FRAMES_MAINTENANCE_DESCRIPTION:
    'There are no available frames based on your criteria and dates. You can create a new plan and update your criteria.',
  NO_AVAILABLE_FRAMES_MAINTENANCE_TITLE: 'Try different criteria - no available frames',
  NO_AVAILABLE_FRAMES_TITLE: 'Edit plan - no available frames',
  PLAN_CM_BOOKING_TIMEOUT_TITLE: 'Plan booking is taking longer than expected',
  PLAN_CM_CANCEL_TIMEOUT_TITLE: 'Maintenance plan cancellation is taking longer than expected',
  PLAN_CREATION_TIMEOUT_TITLE: 'Plan creation is taking longer than expected',
  PLAN_RENEW_TIMEOUT_TITLE: 'Plan renewal is taking longer than expected',
  PLAN_RESERVATION_TIMEOUT_TITLE: 'Plan reservation is taking longer than expected',
  PLAN_TIMEOUT_DESCRIPTION: 'Things are still in progress on our side. A page refresh will show any updates.',
  PLAN_UNRESERVATION_TIMEOUT_TITLE: 'Plan unreservation is taking longer than expected',
  SCHEDULE_CREATION_FAILED: 'Schedule creation failed.',
  SCHEDULE_RENEW_FAILED: 'Schedule renewal failed.',
  SWAP_FRAMES_OR_EDIT_PLAN: 'You can swap frames from another campaign or edit the plan to update your criteria.',
};

export const HEADING_CONTENT_PAGE_LABELS = {
  CONTENT_ALLOCATION: 'Content Allocation',
  CONTENT_CAMPAIGNS: 'Content campaigns',
  CONTENT_LIBRARY: 'Content library',
  CONTENT_MODERATION: 'Content moderation',
  CONTENT_NEW_ALLOCATION: 'New allocation', // delete later
  LINK_CAMPAIGNS: 'Link campaigns',
  RECEIVED_CONTENT: 'Received content',
};

export const CONTENT_HISTORY_LABELS = {
  FETCH_ERROR: 'Link history could not be loaded',
  LINKED_TO: 'Linked to',
  LINK_CHANGE_TITLE: 'Linked/Unlinked to campaign(s)',
  LOADING: 'Loading history…',
  RECEIVED_FROM: 'Received from',
  TITLE: 'Action history',
  UNKNOWN_CAMPAIGN: 'Unknown campaign',
  UNLINKED_FROM: 'Unlinked from',
  UPLOADED_FROM: 'Uploaded from',
};

export const CONTENT_LINK_CAMPAIGNS_LABELS = {
  BACK_TO_CONTENT_LIBRARY: 'Back to Content Library',
  CAMPAIGNS_SECTION_TITLE: 'Campaigns',
  CAMPAIGN_PICKER: {
    ALREADY_LINKED: 'Already linked',
    CAMPAIGNS_AVAILABLE: (total: number) => `${total} campaigns available`,
    CAMPAIGNS_MATCHING: (matching: number) => `${matching} matching on this page`,
    CAMPAIGNS_SELECTED: (selected: number) => `${selected} campaigns selected across pages`,
    EMPTY: 'No campaigns are available.',
    EMPTY_SEARCH: 'No campaigns match this search.',
    ERROR_MESSAGE: 'Refresh the campaign picker and try again.',
    ERROR_TITLE: 'Campaigns could not be loaded',
    FILTER_SORT: 'Filter & Sort',
    FILTER_SORT_PANEL: {
      ACCOUNTS: 'Accounts',
      ACCOUNTS_ERROR: 'Accounts could not be loaded',
      ACCOUNTS_ERROR_MESSAGE: 'Try again to filter by account.',
      ACCOUNTS_LOADING: 'Loading accounts...',
      ACCOUNTS_PLACEHOLDER: 'Filter by accounts',
      ACCOUNTS_RETRY: 'Retry',
      APPLY: 'Apply',
      CLEAR_ALL: 'Clear all',
      CLOSE_ARIA_LABEL: 'Close filter and sort',
      DATES: 'Dates',
      DATE_FIELD_INVALID: 'Enter a valid date',
      DATE_FROM: 'From',
      DATE_RANGE_INVALID: "From date can't be after To date",
      DATE_TO: 'To',
      PRIMARY_SORT: 'Primary sort',
      SORT_BY: 'Sort by',
      SORT_DIRECTION_ARIA_LABEL: 'Sort direction',
      SORT_FIELD_ARIA_LABEL: 'Sort field',
      TITLE: 'Filter & Sort Campaigns',
    },
    HEADING: 'Campaigns',
    LOADING: 'Loading campaigns...',
    NEXT: 'Next',
    PREVIOUS: 'Previous',
    RANGE: (start: number, end: number, total: number) => `${start}–${end} of ${total}`,
    RETRY: 'Retry',
    ROW_ACTIONS_ARIA_LABEL_PREFIX: 'Actions for',
    SEARCH_ARIA_LABEL: 'Search campaigns by name, quote number or reference',
    SEARCH_LABEL: 'Search campaigns',
    SEARCH_PLACEHOLDER: 'Search campaigns...',
    SELECT_ALL_ARIA_LABEL: 'Select all campaigns on this page',
    SELECT_ARIA_LABEL_PREFIX: 'Select',
    VIEW_SALESFORCE_QUOTE: 'Salesforce Quote',
  },
  CAMPAIGN_UNAVAILABLE: 'Campaign unavailable',
  CONFIRMATION: {
    BACK_BUTTON: 'Back to Content Library',
    DOWNLOAD_BUTTON: 'Download content',
    DOWNLOAD_ERROR: 'Failed to download files, please try again later',
    DOWNLOAD_IN_PROGRESS: 'Your files are being downloaded. Please wait a moment...',
    LINKED_TO_CAMPAIGNS: (count: number) => `Linked to ${count} campaign${count === 1 ? '' : 's'}`,
    NO_CHANGES_TEXT: 'No linking or unlinking has happened',
    TITLE: 'Content successfully linked to campaigns',
    UNLINKED_TO_CAMPAIGNS: (count: number) => `Unlinked from ${count} campaign${count === 1 ? '' : 's'}`,
  },
  CONFLICT_BANNER: {
    BODY: 'The selected content is currently being linked/unlinked to campaigns by someone else. Please refresh the page to see changes.',
    REFRESH_BUTTON: 'Refresh',
    TITLE: 'Refresh to see changes - content already linked/unlinked elsewhere',
  },
  CONTENT_SECTION_TITLE: 'Content',
  CREATE_LINK: 'Create link',
  DISABLED_CREATE_LINK_TOOLTIP: 'Select content and campaigns to link',
  EMPTY_CAMPAIGNS_TEXT: 'No campaigns linked yet',
  LINKED: 'Linked',
  LOADING_CONTENT: 'Loading selected content...',
  LOAD_ERROR: 'Something went wrong while loading the selected content. Please try again.',
  NOT_LINKED: 'Not linked to any campaign.',
  NO_DATE_RANGE: 'No date range available',
  NO_PREVIEW_AVAILABLE_ALT: 'No preview available',
  REMOVE_CAMPAIGN_ARIA_LABEL_PREFIX: 'Remove',
  RETRY: 'Retry',
  SAVE_CAMPAIGN_LINKS: 'Save campaign links',
  SELECT_ALL: 'Select all',
  SELECT_CONTENT_ARIA_LABEL_PREFIX: 'Select',
  SUBMIT_ERROR: 'Something went wrong while saving campaign links. Please try again.',
  TABLE_HEADERS: {
    ACCOUNTS: 'Accounts',
    BUYER_REF: 'Buyer ref',
    CAMPAIGN_NAME: 'Campaign name',
    DATE_RANGE: 'Date range',
    ERP_REF: 'ERP ref',
    PRODUCTS: 'Products',
    QUOTE_NUMBER: 'Quote',
  },
  UNKNOWN_MEDIA_TYPE: 'Unknown',
};

export const ERROR_HANDLING_LABELS = {
  CONNECTING_TO_SERVICES: "We're trying to reconnect to services...",
  CONSTRAINTS_SERVICE_ERROR_DESCRIPTION:
    'The constraints service is currently unavailable. This may affect automated and manual constraints.',
  CONSTRAINTS_SERVICE_ERROR_TITLE: "Retry - the constraints service didn't respond",
  CONSTRAINT_SERVICE_UNAVAILABLE_DESCRIPTION:
    'We had trouble connecting to the constraints service. As this could be a temporary issue, please retry connecting in a few minutes.',
  COPY_TECHNICAL_INFORMATION: 'Copy technical information',
  ERROR_REFERENCE: 'Reference digest',
  FRAME_SERVICE_ERROR_TITLE: "Retry - the frame service didn't respond",
  FRAME_SERVICE_UNAVAILABLE_DESCRIPTION:
    'We had trouble connecting to the frame service. As this could be a temporary issue, please try again in a few minutes.',
  GO_HOME: 'Go home',
  INFORMATION_COPIED: 'Information copied!',
  MESSAGE_GENERAL: 'An error occurred',
  ORDER_UPDATE_FAILURE_MESSAGE:
    'Something went wrong while updating this booking in downstream services such as Oasis, Broadsign or the core system. Please open the Salesforce Order for more details.',
  ORDER_UPDATE_FAILURE_TITLE: 'Order update unsuccessful',
  ORDER_UPDATE_OOC_FAILURE: {
    ACTION:
      'To book the plan, you need to remove all out-of-charge frames through swaps form and retrigger the integration in Salesforce.',
    MESSAGE: 'There are out-of-charge frames in the schedule. This caused the booking to fail.',
    TITLE: 'Remove out-of-charge frames - booking attempt failed',
  },
  PLEASE_REPORT: 'Please report this error if the problem persists',
  RETRYING: 'Retrying...',
  SOMETHING_WENT_WRONG: 'Something went wrong',
  SYSTEM_FAILURE_SUPPORT: {
    /* eslint-disable sort-keys */
    MESSAGE_TEXT: 'Please copy the technical information below and contact the team by',
    MESSAGE_TEXT_RETRY: 'If the issue persists, please copy the technical information below and contact the team by',
    LINK_TEXT: 'raising a support ticket',
    /* eslint-enable sort-keys */
  },
  TECHNICAL_INFORMATION: {
    /* eslint-disable sort-keys */
    TRACE_ID: 'Trace ID',
    TIMESTAMP: 'Timestamp',
    SERVICE: 'Service',
    SCHEDULE_ID: 'Schedule ID',
    /* eslint-enable sort-keys */
  },
  TEMPORARY_ISSUE_TRY_AGAIN: 'As this could be a temporary issue, please try again in a few minutes.',
  TRY_AGAIN: 'Try again',
  TRY_AGAIN_IN_A_BIT: 'Try again in a bit',
  // eslint-disable-next-line sort-keys
  UNSUCCESSFUL_PLAN_CREATION: 'Plan creation unsuccessful',
  UNSUCCESSFUL_RESERVATION: 'Reservation unsuccessful',
  UNSUCCESSFUL_UNRESERVATION: 'Unreservation unsuccessful',
};

export const BEFORE_UNLOAD_LABELS = {
  BEFORE_UNLOAD: 'You have unsaved changes. Are you sure you want to leave this page?',
};
export const CONTENT_ALERT_LABELS = {
  REFRESH: 'Please avoid refreshing the page. ',
  UNSAVED_CHANGES: 'If you leave this page without submitting, any moderation statuses will be lost.',
};

export const PROOF_FILTERS_LABELS = {
  CHECK_PROOF: 'Check Proof',
  CREATIVES_LABEL: 'No. of Creatives',
  END_DATE_FIELD_LABEL: 'End Date',
  END_DATE_FIELD_REQUIRED: 'Please select the end date',
  FRAMES_LABEL: 'No. of Frames',
  PLAYS_LABEL: 'No. of Plays',
  SCREENSHOTS_SUMMARY_LABEL: 'Unique Screenshots for campaign',
  SEARCH_FIELD_LABEL: 'Search Campaign ID',
  START_DATE_FIELD_LABEL: 'Start Date',
  START_DATE_FIELD_REQUIRED: 'Please select the start date',
  SUMMARY_LABEL: 'Campaign Delivery Summary',
};

export const RULE_DETAILS_LABELS = {
  BUTTON_BACK_TO_RULES: 'Back to Constraints',
  BUTTON_EDIT_RULE: 'Edit',
  BUTTON_OPEN_IN_PAGE_VIEW: 'Open in page view',
  BUTTON_VIEW_HISTORY: 'View history',
  DATE_CREATED: 'Created',
  DATE_LAST_UPDATED: 'Last updated',
  FIELD_ACCOUNTS: 'Accounts',
  FIELD_CONTENTS: 'Contents',
  FIELD_DESCRIPTION: 'Description',
  FIELD_EXCLUDES: 'Excludes',
  FIELD_INCLUDES: 'Includes',
  FIELD_PRODUCT_CATEGORIES: 'Product categories',
  FRAMES_LABEL: 'frames',
  FRAME_LISTS_LABEL: 'Frame lists',
  HIDE_CHIP_LABEL: 'Hide',
  LABEL_RULE_STATUS: 'Status',
  MESSAGE_NO_CONDITIONS: 'No conditions',
  MESSAGE_NO_DESCRIPTION: 'No description available for this rule',
  MESSAGE_NO_EXCEPTIONS: 'No exceptions',
  MESSAGE_NO_FRAME_SELECTION: 'No frame selection',
  RULE_HISTORY: 'Rule history',
  SHEET_NAME_FRAME_IDS: 'Constraint Frame IDs',
  STATUS_ACTIVE: 'Active',
  STATUS_INACTIVE: 'Inactive',
  TITLE_CANNOT_PLAY: 'Cannot play',
  TITLE_EXCEPT_FOR: 'Except for',
  TITLE_FRAME_SELECTION: 'Frames',
  TITLE_RULE_DETAILS: 'Rule details',
  TOTAL_NUMBER_OF_FRAMES_LABEL: 'Total number of frames',
};

export const VIEW_HISTORY_MODAL_LABELS = {
  ACCOUNT: 'account',
  ADDED_COMMENT: 'Added a comment',
  ADDED_DESCRIPTION: 'Added description',
  ADDED_LABEL: 'Added',
  ADDED_NAME: 'Added name',
  CONTENT: 'content',
  CREATED: 'Created',
  DELETED_LABEL: 'Deleted',
  FORMER_UNKNOWN_USER: 'Former/unknown user',
  FRAME: 'frame',
  FRAME_LIST: 'frame list',
  FRAME_LIST_HISTORY: 'Frame list history',
  FRAME_LIST_TYPE: 'Frame List',
  FROM_CANNOT_PLAY: 'from "cannot play"',
  FROM_EXCEPTIONS: 'from "exceptions"',
  FROM_FRAME_SELECTION: 'from "frame selection"',
  NO_HISTORY: 'No history available',
  PRODUCT_CATEGORY: 'product category',
  REMOVED: 'Removed',
  REMOVED_DESCRIPTION: 'Removed description',
  RULE_HISTORY: 'Rule history',
  RULE_TYPE: 'Constraint Rule',
  SYSTEM_USER: 'System',
  TO_CANNOT_PLAY: 'to "cannot play"',
  TO_EXCEPTIONS: 'to "exceptions"',
  TO_FRAME_SELECTION: 'to "frame selection"',
  UPDATED_DESCRIPTION: 'Updated description',
  UPDATED_LABEL: 'Updated',
  UPDATED_NAME: 'Updated name',
};

export const CONSTRAINTS_FORM_LABELS = {
  CHANGES: 'Changes',
  CURRENT: 'Current',
  FRAME_IDS_COUNT: 'Frame ID Count',
  INITIAL: 'Initial',
};

export const FRAME_SERVICE_LABELS = {
  GENERIC_ERROR_DESCRIPTION:
    'We had trouble connecting to the frame service. As this could be a temporary issue, please retry in a few minutes.',
  GENERIC_ERROR_TITLE: 'Frame service has an issue processing your request',
};

export const FRAME_SWAP_FORM_LABELS = {
  ACHIEVED: 'Achieved',
  ACHIEVED_GOAL: 'Achieved goal',
  ADDED_TO: 'added to',
  ADVANCED_MODE_FULL_SHARE_OF_TIME_DUPLICATE: {
    /* eslint-disable sort-keys */
    TITLE: 'Some inserted frames already exist in this plan',
    MESSAGE: 'These frames were added to your selections, but already exist in your plan.',
    FOOTER: 'Please be aware that this might result in a non-standard share of time.',
    /* eslint-enable sort-keys */
  },
  ADVANCED_MODE_MANUAL: 'Advanced mode (Manual)',
  ADVANCED_MODE_MANUAL_ERROR_MESSAGE: 'The following frame IDs are invalid:',
  ADVANCED_MODE_MANUAL_WARNING_MESSAGE: 'The following frame IDs were not found or are not eligible as donor frames:',
  AD_ASTRA_PLAN: 'AdAstra plan',
  AD_DURATION: 'Ad duration',
  ALERT: {
    /* eslint-disable sort-keys */
    LOCKED_PLANS: {
      TITLE: 'These plans are locked',
      MESSAGE:
        "If you'd like to use any of these plans as donors, unlock them on the summary page of each plan. Then you can find them in the Available tab. You may need to refresh this page.",
    },
    AVERAGED_PLANS: {
      TITLE: 'These plans have averages enabled',
      MESSAGE: "If you'd like to use any of these frames, you'll need to remove them from the plans they are part of.",
    },
    /* eslint-enable sort-keys */
  },
  AUTOMATED_CONSTRAINTS: 'Automated constraints',
  AVAILABLE_REPLACEMENT_NO: 'No',
  AVAILABLE_REPLACEMENT_UNKNOWN: 'Unknown',
  AVAILABLE_REPLACEMENT_YES: 'Yes',
  BUTTON: {
    SWAP_FRAMES: {
      DISABLED_TOOLTIP_REASON: {
        AVAILABILITY_OOC_CHECK_IN_PROGRESS: 'Checking for OOC frames',
        DUPLICATE_FRAMES_BLOCKED_MESSAGE: "You can't proceed with duplicates.",
        DUPLICATE_FRAMES_FULL_SHARE_OF_TIME_MESSAGE:
          'Duplicate frames can only be selected for 100% share of time plans.',
        NO_FRAMES_SELECTED_MESSAGE: 'Select at least one frame to continue.',
        NO_SELECTED_FRAMES_ARE_REPLACEABLE_MESSAGE: 'None of the selected frames are replaceable.',
        OUT_OF_CHARGE_AVAILABILITY_FRAMES:
          'You need to remove the availability out-of-charge frames in order to proceed',
        OUT_OF_CHARGE_DONOR_FRAMES: 'You need to remove the donor out-of-charge frames in order to proceed',
        REPLACEMENT_FRAME_CHECKS_IN_PROGRESS: 'Replacement frame checks are still in progress.',
      },
      LABEL: 'Swap frames',
    },
    YES_SWAP_FRAMES: 'Yes, swap frames',
  },
  CLEAR_SELECTION: 'Clear selection',
  COLLAPSE_ALL: 'Collapse all',
  DATE_RANGE: 'Date range',
  DAYS: 'Days',
  DONOR_PLAN: 'Donor plan',
  ENRICHING_COMPATIBLE_FRAMES: 'Checking frame compatibility for candidate plans…',
  ENRICHMENT_PARTIAL_FAILURE: 'Compatibility check did not complete — showing available results.',
  EXCESS_FRAMES_MODAL: {
    ADVANCED_CTA: 'Are you sure you want to proceed?',
    ADVANCED_WARNING: 'Selection exceeds Needed frames.',
    DESCRIPTION: 'You have selected more frames than you need to achieve the intended goal.',
    STANDARD_REDUCE_CTA: {
      COUNT_OF: ' count of ',
      PLEASE_REMOVE: 'Please remove a few to achieve a ',
    },
    STANDARD_WARNING: 'Cannot exceed Needed frames.',
  },
  EXCLUDED_DAYS: 'Excluded days',
  EXCLUDED_FRAMES: 'Excluded frames',
  EXPAND_ALL: 'Expand all',
  FAILED_FRAMES_SIDEBAR_WARNING: {
    /* eslint-disable sort-keys */
    THESE: 'These',
    THIS: 'This',
    COULD_NOT_BE_USED: 'could not be used as replacements. Please select different frames.',
    /* eslint-enable sort-keys */
  },
  FAILED_TO_LOAD_DONOR_FRAMES: {
    DESCRIPTION:
      'We had trouble connecting to the donor plans. As this could be a temporary issue, please retry connecting in a few minutes.',
    PROCEED_HINT: "You can proceed to the next step if you don't need to add any new frames to the plan.",
    TITLE: "Retry - we couldn't fetch the donor plans",
  },
  FRAME: 'Frame',
  FRAMES: 'Frames',
  FRAMES_SWAPPED_MANUAL_RESERVATION_REQUIRED: 'Manual Reservation Required',
  FRAMES_SWAPPED_NO_SWAPS: {
    AS_REPLACEMENTS: 'as replacements:',
    COULD_NOT_BE_USED: 'could not be used',
    THESE_FRAMES: 'These frames',
    TITLE: 'Try different frames - none of the replacement frames could be used',
  },
  FRAMES_SWAPPED_PARTIALLY: {
    AS_REPLACEMENTS: 'as replacements:',
    CONTINUATION_INSTRUCTION:
      'You can proceed with a partial swap or select different frames to replace the remaining.',
    COULD_NOT_BE_USED: 'could not be used',
    PROCEED_WITH_PARTIAL: 'Proceed with partial swap',
    SELECT_DIFFERENT_FRAMES: 'Select different frames',
    SUCCESSFULLY_ADDED: 'were successfully added to',
    THE_OTHER: 'The other',
    TITLE: 'Replace unsuccessful frames - some of the replacement frames could not be used.',
  },
  FRAMES_SWAPPED_SUCCESSFULLY: 'Frames swapped successfully',
  FRAME_HAS_BEEN_UPDATED_CLEAR_ERRORS: 'This frame has been updated. Refresh your page to clear errors.',
  FRAME_SWAP_ANOTHER_PLAN_VERSION_RESERVED:
    'Another version of this plan is still reserved. Please try reserving manually.',
  FRAME_SWAP_AUTO_RESERVE_FAILED: 'Reserve manually - we could not automatically reserve this version of the plan',
  FRAME_SWAP_AUTO_RESERVE_SUCCESSFUL: 'This draft plan version has automatically been reserved',
  FRAME_SWAP_COMPLETED: 'The frame swap was completed.',
  FRAME_SWAP_DONOR_BACKFILL_FAILED: {
    DESCRIPTION: 'The frames were successfully included in your plan.',
    DETAILS:
      'However, some frames in the campaigns below could not be automatically replaced. Review these plans and add more frames to reach the requested amount.',
    LOADING: 'Retrieving details of affected campaigns...',
    TITLE: 'Check donor campaigns - frames could not be backfilled',
  },
  FRAME_SWAP_DRAFT_PLAN_RESERVE:
    'The recipient plan is currently a draft. Once the swap is complete, the plan will be automatically reserved.',
  FRAME_SWAP_ERROR_CTA: 'If the issue persists, please contact the team by raising a support ticket.',
  FRAME_SWAP_FAILED: 'Frame swap failed',
  FRAME_SWAP_FRAME_AVAILABILITY: {
    NO_AVAILABLE_FRAMES: {
      /* eslint-disable sort-keys */
      NO: 'No',
      AVAILABLE: ' available ',
      FRAMES_TO_SWAP: 'frames to swap. Please select donor frames instead.',
      /* eslint-enable sort-keys */
    },
    SEARCH_IN_PROGRESS: 'Searching for frames matching your criteria...',
  },
  // eslint-disable-next-line sort-keys
  FRAME_SWAP_NOT_ALLOWED: {
    DRAFT_ACHIEVED_FRAMES: {
      DESCRIPTION:
        'Swap frames can only be performed on draft plans that could not get frames due to frame unavailability. If you wish to swap frames into this plan, you need to reserve it first.',
      TITLE: 'Swap frames is not available for draft plans',
    },
    EXCEEDS_TARGET: {
      DESCRIPTION:
        "The number of added frames exceeds what is needed to achieve the plan's target. Please select an appropriate number of replacement frames",
      TITLE: 'Revise swap selection - more frames than needed are added',
    },
  },
  // eslint-disable-next-line sort-keys
  FRAME_SWAP_CONNECTION_ERROR_DESCRIPTION: {
    SWAP_MAY_HAVE_SUCCEEDED:
      'The swap may have been successful, but we were unable to receive confirmation from the swap service. As this could be a temporary issue, please retry connecting.',
    SWAP_NOT_SUBMITTED:
      "The swap didn't go through as we had trouble connecting to the service. As this could be a temporary issue, please retry connecting.",
  },
  FRAME_SWAP_CONNECTION_ERROR_TITLE: 'Retry - we lost connection to the service',
  FRAME_SWAP_GENERIC_ERROR: {
    DESCRIPTION:
      'We had trouble processing the request. As this could be a temporary issue, please retry connecting in a few minutes.',
    TITLE: 'Frame swap has an issue processing your request',
  },
  // eslint-disable-next-line sort-keys
  FRAME_SWAP_ERRORS: {
    ALL_DONORS_FAILED: {
      ACTION: 'Select different frames',
      TITLE: 'Choose different frames - replacement failed',
    },
    AVAILABILITY_CHANGED: {
      ACTION: 'Refresh',
      DESCRIPTION:
        'Availability for some of the frames you selected changed while you were setting up the swap. Please reload the form and try again.',
      TITLE: 'Refresh swaps form - availability changed',
    },
    BROADSIGN_REJECTION: {
      ACTION: 'Select replacement frames',
      TITLE: 'Choose different frames - swap rejected by the external booking system',
    },
    BROADSIGN_SYNC_FAILED: {
      ACTION: 'Contact support',
      FAILED_FRAMES_TITLE: 'These frames could not be synchronised with Broadsign:',
      PARTIAL_DESCRIPTION:
        'Some changes were applied, but one or more updates could not be synchronised with Broadsign. Please contact support.',
      TITLE: 'Contact support - swap was not synchronised with the external booking system',
    },
    DONOR_FRAMES_MISSING: {
      ACTION: 'Refresh',
      DESCRIPTION:
        'Availability for some of the donor frames you selected changed while you were setting up the swap. Please reload the form and try again.',
      TITLE: 'Refresh swaps form - availability changed',
    },
    EMPTY_RECIPIENT: {
      ACTION: 'Select replacement frames',
      DESCRIPTION:
        'You are removing all frames from the recipient. As the plan cannot be left empty, you need to select at least one replacement frame.',
      TITLE: 'Select replacement frames - plan will be empty',
    },
    FRAME_LOCK_FAILED: {
      ACTION: 'Select replacement frames',
      TITLE: 'Choose different frames - frames are unavailable',
    },
    NOTHING_TO_SWAP: {
      ACTION: 'Select replacement frames',
      TITLE: 'Select frames - no frames selected',
    },
    OOC_FRAMES_PRESENT: {
      ACTION: 'Select replacement frames',
      DESCRIPTION:
        'The following frames have out-of-charge periods in the schedule. Please remove them and try booking again.',
      TITLE: 'Choose different frames - out-of-charge frames found',
    },
    SCHEDULE_DATA_MISSING: {
      ACTION: 'Contact support',
      TITLE: 'Contact support - schedule data missing',
    },
    SCHEDULE_VALIDATION_FAILED: {
      ACTION: 'Contact support',
      DESCRIPTION: "The swap couldn't complete as the schedule is not in Reserved or Booked status.",
      TITLE: 'Contact support - plan and schedule statuses are not in sync',
    },
  },
  FRAME_SWAP_LOADING: 'Processing your frame swaps request...',
  /* eslint-disable sort-keys */
  FRAME_SWAP_MID_FLIGHT_WARNING: {
    TITLE: 'Inform the content team - plan is live or starting soon',
    DONOR_PLAN: {
      BEFORE: 'The donor plan is live or scheduled to go live soon. If you take frames from it, please ',
      BOLD: 'inform the content team',
      AFTER: ' as they may need to reschedule the creative.',
    },
    RECIPIENT_PLAN: {
      BEFORE: 'The recipient plan is live or scheduled to go live soon. If you complete the swap, please ',
      BOLD: 'inform the content team',
      AFTER: ' as they may need to reschedule the creative.',
    },
  },
  FRAME_SWAP_NO_REPLACEMENT_FOR_SELECTED_FRAMES: {
    DESCRIPTION: 'Please select frames from the donor plans that have available replacements.',
    TITLE: 'None of the selected frames have available replacements',
  },
  FRAME_SWAP_NO_REPLACEMENT_FRAMES_SELECTED: {
    DESCRIPTION: 'Proceeding with the swap will remove the frames you selected but not add any new ones.',
    TITLE: 'There were no replacement frames selected',
  },
  FRAME_SWAP_NO_SELECTED_FRAMES: {
    DESCRIPTION_1:
      "You can't swap frames unless at least one frame is selected. Please select frames to remove from your plan and/or replacement frames in order to continue.",
    DESCRIPTION_2: 'If you no longer want to make this swap, please go back to plan.',
    TITLE: 'No selected frames',
  },
  FRAME_SWAP_PLAN_ALREADY_HAS_RESERVATION: 'It seems this plan already has a reservation.',
  FRAME_SWAP_PLAN_AUTO_RESERVED: 'This plan will be automatically reserved',
  FRAME_SWAP_PLAN_AUTO_RESERVE_NOT_DONE: 'The new plan version seems to have failed to be reserved.',
  FRAME_SWAP_RECIPIENT_GAPFILL_FAILED: {
    DESCRIPTION: 'The frames were successfully included in your plan.',
    DETAILS:
      'However, some frames in this plan could not be added to all the dates. You can check this by reviewing the day distribution on frameIDs. Please add more frames to the missing days, or remove the failed frames via the swaps form.',
    TITLE: 'Check plan frames - some days could not be filled',
  },
  FRAME_SWAP_RESERVING_DRAFT_PLAN: 'Reserving draft plan...',
  FRAME_SWAP_SELECT_REPLACEMENT_FRAMES: 'Select replacement frames',
  FRAME_SWAP_SUBMITTING: 'Submitting your frame swaps request...',
  FRAME_SWAP_SUCCESSFUL_RESERVE_PROMOTE_FAILED:
    'Frame swap completed successfully, but the plan could not be promoted to RESERVED status. Please manually unreserve any existing reserved version and then reserve this plan.',
  FRAME_SWAP_TIMEOUT_DESCRIPTION:
    'This is taking longer than expected. As it could be a temporary issue, please retry connecting.',
  FRAME_SWAP_TIMEOUT_TITLE: 'Retry - swaps timeout',
  FROM_AVAILABILITY: 'From availability',
  GOAL_SCREENS_PER_DAY: 'frames per day', // Note: keep this key name as 'GOAL_SCREENS_PER_DAY', and the string value as 'frames per day'
  INSERT_FRAMES: 'Insert frames',
  MANUAL_CONSTRAINTS: 'Manual constraints',
  MORE_CAMPAIGN_INFO: 'More campaign info',
  NEEDED: 'Needed',
  NONE_APPLIED: 'None applied',
  NON_REPLACEABLE_FRAMES: 'non-replaceable frames',
  NO_DONOR_FRAMES_SELECTED: 'No donor frames selected',
  NO_DONOR_PLANS_AVAILABLE: {
    /* eslint-disable sort-keys */
    NO: 'No',
    BOOKED_OR_RESERVED: ' booked or reserved ',
    DONOR_PLANS_AVAILABLE: 'donor plans available for a frame swap.',
    /* eslint-enable sort-keys */
  },
  NO_REPLACEMENT_DONOR_FRAMES_ADVANCED: {
    DESCRIPTION: 'will be taken and need to be manually topped up after this swap.',
    WARNING: "Some frames won't be replaced",
  },
  NO_REPLACEMENT_DONOR_FRAMES_CONFIRMATION: 'Continue anyway?',
  NO_REPLACEMENT_DONOR_FRAMES_STANDARD: {
    DESCRIPTION: "won't be used.",
    WARNING: "Some frames won't be replaced",
  },
  OUT_OF_CHARGE_AVAILABILITY: {
    TITLE: 'Remove availability out-of-charge frames - swaps will not complete',
    // eslint-disable-next-line sort-keys
    MESSAGE:
      'We detected out-of-charge frames in the availability selection. To proceed with the swap, you need to remove them.',
    REMOVE_BUTTON: 'Remove from selection',
  },
  OUT_OF_CHARGE_DONOR: {
    BOOKED_PLAN_MESSAGE:
      'This booked plan has out-of-charge frames. To select any donor frames from the plan, you need to remove the out-of-charge ones.',
    FRAME_TOOLTIP: 'Out-of-charge frames cannot be selected.',
    TITLE: 'Remove donor out-of-charge frames - swaps will not complete',
    // eslint-disable-next-line sort-keys
    MESSAGE:
      'We detected out-of-charge frames in the donor selection. To proceed with the swap, you need to remove them.',
    REMOVE_BUTTON: 'Remove from selection',
  },
  OUT_OF_CHARGE_RECIPIENT: {
    ADD_TO_FRAME_REMOVAL: 'Add to frame removal',
    CHECK_ERROR_DESCRIPTION: 'We were unable to verify out-of-charge frames for this plan. Please retry to continue.',
    CHECK_ERROR_TITLE: 'Unable to verify out-of-charge frames',
    DESCRIPTION:
      'We detected out-of-charge frames in the recipient plan. To proceed with the swap, you need to remove them.',
    LOADING: 'Checking for out-of-charge frames...',
    NEXT_DISABLED_TOOLTIP:
      'You need to add the out-of-charge frames to the frame removal selection in order to proceed.',
    TITLE: 'Remove recipient out-of-charge frames - swaps will not complete',
  },
  REMOVED_FROM: 'removed from',
  REMOVE_FRAMES: 'Remove frames',
  REMOVE_FRAMES_ERROR_MESSAGE: 'The following frame IDs are invalid or not part of the recipient plan:',
  REMOVING: 'Removing',
  REPLACEMENT_FILL_STRATEGY: {
    /* eslint-disable sort-keys */
    INPUT_LABEL: {
      RECIPIENT: 'Recipient',
      DONOR: 'Donor',
    },
    INPUT_OPTIONS: {
      ALL_DAYS: 'All days',
      OVERLAP_DAYS: 'Overlap days',
    },
    /* eslint-enable sort-keys */
  },
  REPLACEMENT_FRAMES_STEP_DONOR_PLAN_CATEGORIES: {
    AVERAGES: 'Averages',
    DONORS: 'Donors',
    LOCKED: 'Locked',
  },
  REPLACEMENT_LOGIC_PREVIEW_WINDOW: {
    /* eslint-disable sort-keys */
    INITIATOR_TOOLTIP: 'Click to visualize how your selected replacement logic affects both campaigns.',
    LOADING_MESSAGE: "We're generating replacement preview...",
    TITLE: 'Replacement preview',
    DAYS_WITH_NO_CHANGES_WARNING: 'Might result in an averages campaign.',
    KEY: {
      TAKEN_FROM_PLAN: 'Taken from Plan',
      FILLED_FROM_AVAILABLE: 'Filled from Available',
      NO_REPLACEMENT: 'No backfill',
      NO_CHANGES: 'No changes',
    },
    INFORMATION: {
      TITLE: 'Replacement logic',
      MESSAGE: {
        SENTENCE_1:
          'We recommend taking a frame for the full period of the recipient campaign and backfilling it for the full period of the donor plan.',
        SENTENCE_2: 'For low availability, you can choose to replace only for the days when both campaigns overlap.',
      },
    },
    /* eslint-enable sort-keys */
  },
  REQUESTED: 'Requested',
  REQUESTED_GOAL: 'Requested goal',
  SCROLL_TO_TOP: 'Scroll to top',
  SEC: 'sec',
  SELECTED_MULTIPLE_TIMES: 'selected multiple times',
  SHARE_OF_TIME: 'Share of time',
  SPARES: 'Spares',
  STEPPER: {
    STEP: {
      /* eslint-disable sort-keys */
      ONE: {
        LABEL: 'Remove frames',
        FORM_SECTION_HEADING: 'Remove frames from plan',
      },
      TWO: {
        LABEL: 'Available frames',
        FORM_SECTION_HEADING: 'Available frames',
      },
      THREE: {
        LABEL: 'Donor frames',
        FORM_SECTION_HEADING: 'Add frames from other campaigns',
      },
      FOUR: {
        LABEL: 'Preview swaps',
        FORM_SECTION_HEADING: 'Preview swap replacements',
      },
      FIVE: {
        LABEL: 'Confirmation',
        FORM_SECTION_HEADING: '',
      },
      /* eslint-enable sort-keys */
    },
  },
  SUMMARY: {
    HEADING: 'Summary',
  },
  TABLE_HEADER: {
    AVAILABLE_REPLACEMENT: 'Available Replacement?',
    CAMPAIGN_INFO: 'Campaign info',
    CAMPAIGN_NAME: 'Campaign name',
    DATE_RANGE: 'Date range',
    FRAME_GOAL_ACHIEVED: 'Frame goal (achieved)',
    FRAME_ID: 'Frame ID',
    LOCATION: 'Location',
    REPLACEMENT_LOGIC: 'Replacement logic',
    SALESPERSON: 'Salesperson',
    SHARE_OF_TIME: 'Share of time',
    SPARES: 'Included spares',
    STATUS: 'Status',
    VENUE: 'Venue',
  },
  TABLE_HEADER_TOOLTIP: {
    AVAILABLE_REPLACEMENT:
      'We automatically replace frames taken from other campaigns with available ones matching their criteria.',
    REPLACEMENT_LOGIC: {
      PARAGRAPH_1:
        'We aim to take a frame for the full period of the recipient campaign and backfill it for the full period of the donor plan.',
      PARAGRAPH_2: 'For more availability, you can choose to replace only for the days when both campaigns overlap.',
    },
  },
  TABLE_SEARCH_PLACEHOLDER: 'Search frame ID, venue, location...',
  TOOLTIP_DELETE_FRAME: 'Delete frame',
  TOOLTIP_OPEN_PLAN: 'Open plan',
  TOOLTIP_OPEN_SALESFORCE: 'Open Salesforce',
  VERSION: 'version',
  YOU_REMOVED_FRAMES: 'You removed',
};

export const IMPORTED_SCHEDULES_PAGE_LABELS = {
  CONTRACT_ID: 'Contract Id',
  CREATED_AT: 'Created At',
  FILTER_BY_CONTRACT_ID: 'Filter by Contract Id',
  FRAMES: 'Frames',
  ORDER_LINE: 'Order Line',
  SCHEDULE: 'Schedule',
};
